module.exports = __webpack_public_path__ + "img/1f639.2c5fd3e.svg";